import creditcard from './creditcard';
import neteller from './neteller';
import skrill from './skrill';
import paypal from './paypal';
import zimpler from './zimpler';
import paysafecard from './paysafecard';
import trustly from './trustly';
import muchbetter from './muchbetter';
import venuspoint from './venuspoint';
import vega from './vega';
import bank from './bank';
import bankiban from './bankiban';
import instadebit from './instadebit';
import idebit from './idebit';
import ideal from './ideal';
import epro from './epro';
import siru from './siru';
import ppro from './ppro';
import ecopayz from './ecopayz';
import reversewithdrawal from './reversewithdrawal';
import swish from './swish';
import webredirect from './webredirect';
import mobilepay from './mobilepay';
import funanga from './funanga';
import astropaycard from './astropaycard';
import communitybank from './communitybank';
import jeton from './jeton';
import cryptocurrency from './cryptocurrency';
import bestpay from './bestpay';
import ezeewallet from './ezeewallet';
import mifinity from './mifinity';
import cashlib from './cashlib';
import apco from './apco';
import pradexx from './pradexx';

export default {
  creditcard: creditcard,
  neteller: neteller,
  skrill: skrill,
  venuspoint: venuspoint,
  vega: vega,
  paypal: paypal,
  zimpler: zimpler,
  paysafecard: paysafecard,
  muchbetter: muchbetter,
  trustly: trustly,
  bank: bank,
  instadebit: instadebit,
  idebit: idebit,
  ideal: ideal,
  epro: epro,
  siru: siru,
  ppro: ppro,
  ecopayz: ecopayz,
  reversewithdrawal: reversewithdrawal,
  swish: swish,
  bankiban: bankiban,
  mobilepay: mobilepay,
  funanga: funanga,
  webredirect: webredirect,
  astropaycard: astropaycard,
  communitybank: communitybank,
  jeton: jeton,
  cryptocurrency: cryptocurrency,
  bestpay: bestpay,
  ezeewallet: ezeewallet,
  mifinity: mifinity,
  cashlib: cashlib,
  apco: apco,
  pradexx: pradexx
};